import { useContext } from "react";

import { RouteIsActiveContext } from "@lib/routeIsActiveContext";
import type { RouteIsActiveContextType } from "@lib/routeIsActiveContext";

export function useRouteIsActive(): RouteIsActiveContextType {
  return useContext(RouteIsActiveContext);
}
